import axiosApiInstance from "../../../app/axios";
import { getJwtToken } from "../../../app/common";
import { PARKIT_API_BASE_URL } from "../../../app/utils";

export const getSeasonPasses = async (page, size, sort, sortBy, status) =>
  axiosApiInstance.get(
    `${PARKIT_API_BASE_URL}/parkit/v2/season-passes?page=${page}&size=${size}&sort=${sort}&sortBy=${sortBy}&status=${status}`,
    { headers: { Authorization: `Bearer ${getJwtToken()}` } }
  );

export const getSeasonPassWorkflowTasks = async () =>
  axiosApiInstance.get(`${PARKIT_API_BASE_URL}/parkit/v2/workflow/tasks`, {
    headers: { Authorization: `Bearer ${getJwtToken()}` },
  });

const seasonPassUrl = (id) =>
  `${PARKIT_API_BASE_URL}/parkit/v2/season-passes/${id}`;

const auth = () => ({
  headers: { Authorization: `Bearer ${getJwtToken()}` },
});

export const getSeasonPass = (id) =>
  axiosApiInstance.get(seasonPassUrl(id), auth());

export const retrySeasonPassEntitlement = (id) =>
  axiosApiInstance.post(`${seasonPassUrl(id)}/entitlement/retry`, {}, auth());

export const retrySeasonPassVehicleAccess = (id) =>
  axiosApiInstance.post(`${seasonPassUrl(id)}/vehicle-access/retry`, {}, auth());

export const reconcileSeasonPassVehicleAccess = (id) =>
  axiosApiInstance.post(`${seasonPassUrl(id)}/vehicle-access/reconcile`, {}, auth());

export const cancelAndRefundSeasonPass = (id) =>
  axiosApiInstance.post(`${seasonPassUrl(id)}/cancel-and-refund`, {}, auth());

export const forceTerminateSeasonPass = (id) =>
  axiosApiInstance.post(`${seasonPassUrl(id)}/force-terminate`, {}, auth());
